import { NgModule } from '@angular/core';
import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaV3Module,
  RECAPTCHA_V3_SITE_KEY,
} from 'ng-recaptcha';

@NgModule({
  declarations: [],
  imports: [RecaptchaModule, RecaptchaFormsModule, RecaptchaV3Module],
  exports: [RecaptchaModule, RecaptchaFormsModule, RecaptchaV3Module],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LdWc8krAAAAABxuXBc4_o9RLRoEWUYO-E7Vl4Eu' },
  ],
})
export class CaptchaModule { }
